var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCandy = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M19.9999 31.6667C26.4432 31.6667 31.6666 26.4433 31.6666 20C31.6666 13.5567 26.4432 8.33334 19.9999 8.33334C13.5566 8.33334 8.33325 13.5567 8.33325 20C8.33325 26.4433 13.5566 31.6667 19.9999 31.6667Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4834 11.4833L28.5167 3.51667C27.6551 2.655 26.1884 2.98 25.7717 4.125L23.9834 9.04667C27.2167 10.2233 29.7767 12.7833 30.9534 16.0167L35.8734 14.2283C37.0201 13.8117 37.3451 12.345 36.4834 11.4833Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04656 23.9833L4.12656 25.7717C2.97989 26.1883 2.65489 27.655 3.51822 28.5167L11.4832 36.4833C12.3449 37.345 13.8116 37.02 14.2282 35.875L16.0166 30.955C12.7832 29.7767 10.2232 27.2167 9.04656 23.9833Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 26.6667C19.0799 26.6667 18.3333 25.9217 18.3333 25V15C18.3333 14.08 19.0799 13.3333 19.9999 13.3333C20.9199 13.3333 21.6666 14.08 21.6666 15V25C21.6666 25.9217 20.9199 26.6667 19.9999 26.6667Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3283 24.1667C24.045 24.1667 23.7583 24.095 23.4967 23.9433L14.8367 18.9433C14.0383 18.4833 13.7667 17.4633 14.2267 16.6667C14.685 15.8683 15.705 15.5933 16.5033 16.0567L25.1633 21.0567C25.9617 21.5167 26.235 22.5367 25.7733 23.3333C25.4633 23.8683 24.9033 24.1667 24.3283 24.1667Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6718 24.1667C15.0951 24.1667 14.5351 23.8683 14.2268 23.3333C13.7668 22.535 14.0401 21.5167 14.8368 21.0567L23.4968 16.0567C24.2918 15.5967 25.3135 15.8683 25.7735 16.6667C26.2335 17.4633 25.9601 18.4833 25.1635 18.9433L16.5035 23.9433C16.2418 24.095 15.9535 24.1667 15.6718 24.1667Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCandy, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/candy.4eebba21.svg";
export { ForwardRef as ReactComponent };